<template>
	<div>
		<div id="notFound"></div>
	</div>
</template>

<style scoped>

</style>

<script>
	import store from '../store'
	import axios from 'axios'
	import VueAxios from 'vue-axios'
	import router from '../router'
	import { mixin } from '../components/mixins/mixin'

	export default {
		name: 'NotFound',

		mixins: [mixin],

		created: function(){
            const vc = this
            
            if(!window.location.href.includes('/doc')) {
                vc.popUp('Invalid Address','The page you requested could not be found');

                if(window.location.href.includes('/manage'))
                    router.push('/manage')
                else
                    router.push('/')
            }
		}
	}


</script>
